import { dateFormat } from '@/tool/transform.js';
import Axios from "@/tool/axios";

export default class Mission {
    constructor(options) {
        options = options || {};
        for (let attr in options) {
            this[attr] = options[attr];
        }
    }

    // 列表视图 （任务列表查询）
    listMission(data) {
        return Axios({
            url: '/api/wx/mission/listMission',
            method: 'get',
            params: data
        }).then(
            res => {
                // res.data.data = res.data.data || [];
                // res.data.data.map((item) => {
                //     item.createdAtS = item.createdAt ? dateFormat(item.createdAt) : "-";
                //     item.startTimeS = item.startTime ? dateFormat(item.startTime) : "-";
                //     item.endTimeS = item.endTime ? dateFormat(item.endTime) : "-";
                // })
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 任务列表
    listSimpleMission(data) {
        return Axios({
            url: '/api/wx/mission/listSimpleMission',
            method: 'get',
            params: data
        }).then(
            res => {
                // res.data.data = res.data.data || [];
                // res.data.data.map((item) => {
                //     item.createdAtS = item.createdAt ? dateFormat(item.createdAt) : "-";
                //     item.startTimeS = item.startTime ? dateFormat(item.startTime) : "-";
                //     item.endTimeS = item.endTime ? dateFormat(item.endTime) : "-";
                // })
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 历史使用模板top5
    templateHistory(data) {
        return Axios({
            url: '/api/wx/mission/listMissionTemplateHistory',
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 任务模板分类
    templateClassify(data) {
        return Axios({
            url: '/api/wx/mission/listMissionTemplateClassify',
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 任务模板下的任务分类列表
    listMissionByTemplateId(data) {
        return Axios({
            url: '/api/wx/mission/listMissionClassifyByMissionTemplateId',
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 任务列表分列下任务
    missionClassifyPanel(data, missionClassifyId) {
        return Axios({
            url: `/api/wx/mission/listMissionToMissionClassifyPanel/${missionClassifyId}`,
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 项目文档列表（任务附件）
    listMissionAttachment(data) {
        return Axios({
            url: '/api/wx/mission/listMissionAttachment',
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 删除附件
    deleteMissionAttachment(id) {
        return Axios({
            url: `/api/wx/mission/deleteMissionAttachment/${id}`,
            method: 'delete',
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 重命名
    renameMissionAttachment(data, id) {
        return Axios({
            url: `/api/wx/mission/renameMissionAttachment/${id}`,
            method: 'put',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 移动文件
    moveMissionAttachment(data, id) {
        return Axios({
            url: `/api/wx/mission/moveMissionAttachment/${id}`,
            method: 'put',
            data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 项目列表
    listProject(data) {
        return Axios({
            url: '/api/wx/project',
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }
    // 移动文件（任务列表查询）
    childrenMissionList(data) {
        return Axios({
            url: '/api/wx/mission/list',
            method: 'get',
            params: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 看板视图（任务列表查询）
    listMissionBoard(data) {
        return Axios({
            url: '/api/wx/mission/boardList',
            method: 'get',
            params: data,
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    //所有项目的已逾期那列
    listDeadlineMission(data) {
        return Axios({
            url: '/api/wx/mission/listDeadlineMission',
            method: 'get',
            params: data,
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }

    // 看板视图（任务列表查询tab栏总数）
    boardListCount(data) {
        return Axios({
            url: '/api/wx/mission/boardListCount',
            method: 'get',
            params: data,
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        )
    }
    //编辑状态视图任务列表分列
    putMissionClassify(data) {
        return Axios({
            url: `/api/wx/mission/putMissionClassify/${data.id}`,
            method: 'put',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //新增编辑状态视图任务列表分列
    postMissionClassify(data) {
        return Axios({
            url: `/api/wx/mission/postMissionClassify`,
            method: 'post',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 更改任务状态
    updateMissionClassifyId(data) {
        return Axios({
            url: `/api/wx/mission/updateMissionClassifyId`,
            method: 'put',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 任务详情
    getMissionDetail(data) {
        return Axios({
            url: `/api/wx/mission/getMission/${data.id}`,
            // url: 'http://127.0.0.1:4523/m1/3311118-0-default/api/wx/mission/getMission/1',
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 任务标签列表
    listLabel(data) {
        return Axios({
            url: `/api/wx/mission/listLabel`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 新增任务标签
    addLabel(data) {
        return Axios({
            url: `/api/wx/mission/addLabel`,
            method: 'post',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 新增任务标签
    putLabel(data) {
        return Axios({
            url: `/api/wx/mission/putLabel/${data.id}`,
            method: 'put',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 删除任务标签
    deleteLabel(data) {
        return Axios({
            url: `/api/wx/mission/deleteLabel/${data.id}`,
            method: 'delete',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 任务评论列表
    listMissionReply(data) {
        return Axios({
            url: `/api/wx/mission/listMissionReply`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 发布任务评论
    publishMissionReply(data) {
        return Axios({
            url: `/api/wx/mission/publishMissionReply`,
            method: 'post',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //编辑任务评论
    putMissionReply(data) {
        return Axios({
            url: `/api/wx/mission/putMissionReply/${data.id}`,
            method: 'put',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 删除任务评论
    deleteMissionReply(data) {
        return Axios({
            url: `/api/wx/mission/deleteMissionReply/${data.id}`,
            method: 'delete',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //复制任务
    copyMission(data) {
        return Axios({
            url: `/api/wx/mission/copyMission/${data.id}`,
            method: 'post',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 任务移到回收站
    deleteMission(data) {
        return Axios({
            url: `/api/wx/mission/deleteMission/${data.id}`,
            method: 'delete',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 更换公开/隐私模氏
    updatePublicityStatus(data) {
        return Axios({
            url: `/api/wx/mission/updatePublicityStatus/${data.id}`,
            method: 'put',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    // 成员列表
    employee(data) {
        return Axios({
            url: `/api/wx/employee`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //新增任务
    postMission(data) {
        return Axios({
            url: `/api/wx/mission/postMission`,
            method: 'post',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //编辑任务
    putMission(data) {
        return Axios({
            url: `/api/wx/mission/putMission/${data.id}`,
            method: 'put',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //编辑任务单项
    putSingleMission(data) {
        return Axios({
            url: `/api/wx/mission/putMission/v2/${data.id}`,
            method: 'put',
            data: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //任务操作日志
    getMissionLog(data) {
        return Axios({
            url: `/api/wx/operatorLogger/listOperatorLogger/${data.id}`,
            method: 'get',
            params: { logType: 1 }
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //任务列表
    getMissionList(data) {
        return Axios({
            url: `/api/wx/mission`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //获取项目的任务列表分列（状态列表）
    listMissionClassify(data) {
        return Axios({
            url: `/api/wx/mission/listMissionClassify`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //优先级列表
    priority(data) {
        return Axios({
            url: `/api/wx/priority`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //日历视图（任务列表）
    getCalendarList(data) {
        return Axios({
            url: `/api/wx/mission/getCalendarList`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //日历视图（任务列表）——拖拽改变计划时间
    updateTime(data) {
        return Axios({
            url: `/api/wx/mission/updateTime/${data.id}`,
            method: 'put',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    //项目列表
    getProjectList(data) {
        return Axios({
            url: `/api/wx/project/listSimpleProject`,
            method: 'get',
            params: data
        }).then(
            res => {
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }
}



// WEBPACK FOOTER //
// ./src/digitalHuman/tool/classFactory/Mission.js